/** Keep image-search results in view after mobile camera capture and layout swaps. */
export function scrollToImageSearchView(behavior) {
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  const scrollBehavior = behavior || (isMobile ? 'auto' : 'smooth');
  const headerOffset = isMobile ? 88 : 96;

  const run = () => {
    const el =
      document.querySelector('.image-search-results') ||
      document.getElementById('products-section');
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY - headerOffset;
    window.scrollTo({ top: Math.max(0, top), behavior: scrollBehavior });
  };

  requestAnimationFrame(() => requestAnimationFrame(run));
}
